/*
    required HTML structure:

    <div class="js-offerDetailBasicInfo position-relative">
        <div class="js-itemsHiding__items h-100 overflow-hidden">
            <span class="js-itemsHiding__item">
                ITEM
            </span>
            <span class="js-itemsHiding__item">
                ITEM
            </span>
        </div>
        <div class="js-itemsHiding__other h-100">
            <button class="js-itemsHiding__otherItem invisible js-itemsHiding__toggle" type="button" id="dropdownMenu" aria-haspopup="true">
                BTN
            </button>
            <div class="js-itemsHiding__otherElements invisible" aria-labelledby="dropdownMenu">
            </div>
        </div>
    </div>
 */


Bingo.ItemsHiding = {};

Bingo.ItemsHiding.init = function (element) {
    const hideLastItem = () => {
        const lastItem = $(`${element} .js-itemsHiding__items .js-itemsHiding__item:visible`).last();
        lastItem.hide();
        lastItemId = lastItem.data('menu-item');
        $(`.js-itemsHiding__otherElements [data-menu-item=${lastItemId}]`).show();
    };

    const tryShowFirstHiddenItem = () => {
        const lastItem = $(`${element} .js-itemsHiding__items .js-itemsHiding__item:visible`).last();
        lastItemId = lastItem.data('menu-item');
        firstHiddenItemId = parseInt(lastItemId) + 1;
        $(`${element} .js-itemsHiding__items [data-menu-item=${firstHiddenItemId}]`).show();
        $(`${element} .js-itemsHiding__otherElements [data-menu-item=${firstHiddenItemId}]`).hide();
        calculateWidths();
    };

    const canItemsCanBeInMenu = () => {
        let allItemsWidth = 0;
        $(`${element} .js-itemsHiding__items .js-itemsHiding__item:visible`).each(function () {
            allItemsWidth += $(this).outerWidth(true);
        });
        if (allItemsWidth > $(`${element} .js-itemsHiding__items`).width()) {
            return false;
        }
        return true;
    };

    $(`${element} .js-itemsHiding__item`).each(function (i) {
        $(this).attr('data-menu-item', i).clone().appendTo($(`${element} .js-itemsHiding__otherElements`))
            .hide();
    });

    const calculateWidths = () => {
        if (!canItemsCanBeInMenu()) {
            hideLastItem();
            calculateWidths();
            return false;
        }
        if ($(`${element} .js-itemsHiding__items .js-itemsHiding__item:visible`).length < $(`${element} .js-itemsHiding__items .js-itemsHiding__item`).length) {
            $('.js-itemsHiding__other').removeClass('w-0 overflow-hidden');
            $('.js-itemsHiding__otherItem, .js-itemsHiding__otherElements').removeClass('invisible');
        } else {
            $('.js-itemsHiding__other').addClass('w-0 overflow-hidden');
            $('.js-itemsHiding__otherItem, .js-itemsHiding__otherElements').addClass('invisible');
        }
        return true;
    };

    $(window).on('resize load', () => {
        calculateWidths();
        tryShowFirstHiddenItem();
    });

    $(`${element} .js-itemsHiding__toggle`).click(function () {
        $(`${element} .js-itemsHiding__otherElements`).toggle();
        $(this).toggleClass('active');
        return new Popper($(`${element}`), $(`${element} .js-itemsHiding__otherElements`), {
            placement: 'bottom-start',
        });
    });

    $(window).click(() => {
        $(`${element} .js-itemsHiding__toggle`).removeClass('active');
        $(`${element} .js-itemsHiding__otherElements`).hide();
    });
    $(`${element}`).click((event) => {
        event.stopPropagation();
    });

    $(element).removeClass('overflow-hidden');
};
